export { default as Visibility } from "./Visibility.vue";
export { default as VisibilityList } from "./VisibilityList.vue";

export const VisibilityType = Object.freeze({
    PRIVATE: "private",
    PUBLIC: "public",
});

export const visibilities = [
    {
        id: VisibilityType.PRIVATE,
        label: "components.filters.visibility.private",
    },
    {
        id: VisibilityType.PUBLIC,
        label: "components.filters.visibility.public",
    },
];
